export default __webpack_public_path__ + "static/media/logo_horiz.4651a562.svg";